import { ref } from 'vue'

export function useTabPersistence<T extends string>(
  storageKey: string,
  defaultTab: T,
  validTabs?: readonly T[]
) {
  const getPersistedTab = (): T => {
    try {
      const stored = localStorage.getItem(storageKey)
      if (validTabs && stored) {
        return validTabs.includes(stored as T) ? (stored as T) : defaultTab
      }
      return (stored as T) || defaultTab
    } catch {
      return defaultTab
    }
  }

  const activeTab = ref<T>(getPersistedTab()) as any // force typing if needed or fix generic ref

  const handleTabChange = (tabName: T) => {
    activeTab.value = tabName
    try {
      localStorage.setItem(storageKey, tabName)
    } catch {
      // Ignore localStorage errors
    }
  }

  return {
    activeTab,
    handleTabChange,
  }
}
